module.exports = __webpack_public_path__ + "dbfef66bca50f0f073ee4d08354f1ab8.jpg";